import React, { useState } from 'react';
import PopOver from '../../components/deprecated/PopOver';
import { useGetUser } from '../../user/useAllUsers';
import type { MagneticWallItemSize } from '../MagneticWallItem';
import MagneticWallItem from '../MagneticWallItem';
import MagneticWallItemAvatar from '../MagneticWallItemAvatar';
import type { VersionChange } from './calculateVersionChanges';
import VersionChangeCard from './VersionChangeCard';

export type EditVersionChange = VersionChange & {
  type: 'edit';
};

interface EditVersionChangeCardProps {
  versionChange: EditVersionChange;
  focused: boolean;
  onClick: () => void;
  historyInsertedAt: Date;
  initialIsPopOverOpen?: boolean;
  magneticWallItemSize: MagneticWallItemSize;
}

const EditVersionChangeCard = ({
  versionChange,
  focused,
  onClick,
  historyInsertedAt,
  initialIsPopOverOpen = false,
  magneticWallItemSize,
}: EditVersionChangeCardProps) => {
  const [isPopOverOpen, setIsPopOverOpen] = useState(initialIsPopOverOpen);
  const getUser = useGetUser();

  const author = getUser({ id: versionChange.authorId });
  if (!author) return null;

  return (
    <MagneticWallItem.Root
      size={magneticWallItemSize}
      focused={focused}
      id={versionChange.id}
      onClick={onClick}
      compactView={
        <PopOver
          placement="left"
          trigger="click"
          arrow={<PopOver.Container.Arrow small />}
          modifiers={[
            { name: 'offset', options: { offset: [10, 8] } },
            { name: 'preventOverflow', enabled: false },
          ]}
          open={isPopOverOpen}
          onOpenChange={setIsPopOverOpen}
          preventCloseOnContentClick
          popOver={
            <VersionChangeCard.PopOverRoot>
              <VersionChangeCard.Content
                name={author.name}
                insertedAt={historyInsertedAt}
              />
            </VersionChangeCard.PopOverRoot>
          }
        >
          <VersionChangeCard.Root focused={focused} muted={!focused}>
            <VersionChangeCard.CompactAvatarContainer>
              <MagneticWallItemAvatar user={author} />
            </VersionChangeCard.CompactAvatarContainer>
          </VersionChangeCard.Root>
        </PopOver>
      }
      fullView={
        <VersionChangeCard.Root focused={focused} muted={!focused}>
          <MagneticWallItem.Card focused={focused} overlapped={false}>
            <VersionChangeCard.ContentContainer>
              <MagneticWallItemAvatar user={author} />
              <VersionChangeCard.Content
                name={author.name}
                insertedAt={historyInsertedAt}
              />
            </VersionChangeCard.ContentContainer>
          </MagneticWallItem.Card>
        </VersionChangeCard.Root>
      }
    />
  );
};

export default EditVersionChangeCard;
